import { render, staticRenderFns } from "./ColAccountList.vue?vue&type=template&id=68cb19cd&scoped=true"
import script from "./ColAccountList.vue?vue&type=script&lang=js"
export * from "./ColAccountList.vue?vue&type=script&lang=js"
import style0 from "./ColAccountList.vue?vue&type=style&index=0&id=68cb19cd&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68cb19cd",
  null
  
)

export default component.exports